// extracted by mini-css-extract-plugin
export default {"about":"About_about__j3KqT","aboutContent":"About_aboutContent__6zQ9E","textContainer":"About_textContainer__OKMSr","imageContainer":"About_imageContainer__Sx1w3"};